<template>
  <div class="shipment-renderer">
    <span class="shipment-renderer--action">
      <template v-if="isLoading">
        <BackstageIcon name="loading" />
      </template>
      <template v-else-if="showDownloadButton">
        <button
          class="button download-button"
          :class="[{ submitting: params.data?.loading }]"
          :disabled="params.data?.loading"
          v-on:click.stop="onDownload"></button>
      </template>
      <template v-else>
        <BackstageTooltip :text="$t('viewOrders.missingDocument')" placement="top">
          <span class="shipment-renderer__warning" v-on:click.stop>
            <BackstageIcon :name="Icons.TRIANGLE_WARNING" />
          </span>
        </BackstageTooltip>
      </template>
    </span>

    <span class="shipment-renderer--text">
      {{ getOrderDocumentDownloadButtonText(params.value, $t, userLocale) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import BackstageIcon from '@/components/common/BackstageIcon.vue';
import BackstageTooltip from '@/components/common/BackstageTooltip.vue';
import { useLocale } from '@/composables/locale';
import { ordersMixins } from '@/mixins/orders.mixins';
import { Icons } from '@/models/icons.enum';
import { computed } from 'vue';

const props = defineProps<{ params: any }>();

const { userLocale } = useLocale();
const { getOrderDocumentDownloadButtonText } = ordersMixins;

const isLoading = computed(() => props.params?.context?.componentParent?.isEnrichingDocuments);

const showDownloadButton = computed(() => !props.params?.value?.isMissingFile);

const onDownload = () => {
  props.params?.context?.componentParent?.downloadShipment?.(props.params);
};
</script>

<style lang="scss">
.shipment-renderer {
  display: flex;
  align-items: center;

  &--action {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    margin-right: 8px;
    flex: 0 0 28px;
  }

  &--text {
    padding-bottom: 0;
    line-height: 1.2;
  }
}

.shipment-renderer__warning {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
}

.shipment-renderer__warning i.triangle-warning {
  width: 20px;
  height: 20px;
}
</style>
